import PropTypes from 'prop-types';
import React from 'react';
import HamburguerIcon from '../../icons/burger.svg';
import { toggleModalVisibility } from '../../modal/helpers';

const PlaylistButton = ({ config, videoPlayer, playlistmodel }) => {
  if (!playlistmodel.isPlaylist || config?.format === 'vertical') return null;

  const toggleModal = () => {
    toggleModalVisibility('tpx-playlist-modal');
    return videoPlayer.pause();
  };

  return (
    <div className="tpx-fullscreen" onClick={toggleModal}>
      <HamburguerIcon />
    </div>
  );
};

export default PlaylistButton;

PlaylistButton.propTypes = {
  config: PropTypes.object.isRequired,
  videoPlayer: PropTypes.object.isRequired,
  playlistmodel: PropTypes.object.isRequired,
};
